import React, { useState } from "react";
import axios from "axios";
import Footer from "../Fotter";
import endPoint from "../redux/EndPoint/endpoint";
import { useNavigate } from "react-router-dom";
import OrderTracking from "./OrderTracking";
import { toast } from "react-toastify";

const AllOrders = () => {
  const navigation = useNavigate();
  const [orders, setOrders] = useState([]);
  const [estimatedDate, setEstimatedDate] = useState(null);
  const [filter, setFilter] = useState({
    status: {
      Shipped: false,
      Pending: false,
      Delivered: false,
      Cancelled: false,
    },
    orderId: "",
    email: "",
  });
  const storedUuid = localStorage.getItem("uuid");
  const Token = localStorage.getItem("loginData");
  const handleSearchChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };
  const [loading, setLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [reason, setReason] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        endPoint.TrackOrder,
        {
          orderId: filter.orderId || "",
          email: filter.email || undefined,
        },
        {
          headers: {
            sessionId: storedUuid || "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      setEstimatedDate(response?.data?.estimatedDeliveryDate || null);
      if (response.data?.order) {
        setOrders([response.data.order]);
      } else if (response.data?.orders?.length > 0) {
        setOrders([response.data.orders[0]]);
      } else {
        setOrders([]);
      }
    } catch (error) {
      setOrders([]);
      console.error("Error searching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const _handleReview = (item) => {
    navigation("/productDetails", { state: item });
  };

  const handleVerifyOtp = async () => {
    if (!reason?.trim()) {
      toast.error("Reason is required");
      return;
    }

    if (!otp?.trim()) {
      toast.error("OTP is required");
      return;
    }

    if (otp.length < 4) {
      toast.error("Please enter valid OTP");
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        endPoint.VerifyOrderOtp,
        {
          orderId: selectedOrder?.orderId,
          otp: parseInt(otp),
          reason: reason,
        },
        {
          headers: {
            sessionId: storedUuid || "",
            Authorization: Token
              ? `Bearer ${Token}`
              : "",
          },
        }
      );
      toast.success(
        `${selectedAction} Request Submitted Successfully`
      );
      const updatedOrders = orders.map((item) => {
        if (
          item.orderId ===
          selectedOrder.orderId
        ) {
          return {
            ...item,
            status: selectedAction,
          };
        }

        return item;
      });

      setOrders(updatedOrders);
      setShowOtpModal(false);
      setOtp("");
      setReason("");
      setSelectedOrder(null);
      setSelectedAction("");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  };

  const handleActionClick = async (order, action) => {
    setLoading(true);
    try {
      setSelectedOrder(order);
      setSelectedAction(action);
      await axios.post(
        endPoint.SendOrderOtp,
        {
          orderId: order?.orderId,
        },
        {
          headers: {
            sessionId: storedUuid || "",
            Authorization: Token
              ? `Bearer ${Token}`
              : "",
          },
        }
      );

      toast.success("OTP Sent Successfully");
      setShowOtpModal(true);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="w-[90%] items-center justify-center self-center flex-grow mt-[3%] mb-8">
        <main className="flex-grow flex flex-col md:flex-row gap-5">
          <div className="w-full h-[20%] md:w-[30%] lg:w-[20%] bg-white p-5 rounded-lg border border-gray-200 shadow-md">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
              Filter Orders
            </h3>

            <div className="space-y-3 ">
              <div className="relative">
                <input
                  type="text"
                  name="orderId"
                  value={filter.orderId}
                  onChange={handleSearchChange}
                  placeholder="Search by Order ID"
                  className="w-full p-2 pl-10 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
                />
                <span className="absolute left-3 top-3 text-gray-400">🔎</span>
              </div>

              <div>
                <h4 className="text-md font-medium text-gray-700 mb-2 text-center">Or</h4>
              </div>

              <div className="relative">
                <input
                  type="text"
                  name="email"
                  value={filter.email}
                  onChange={handleSearchChange}
                  placeholder="Search by Email"
                  className="w-full p-2 pl-10 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
                />
                <span className="absolute left-3 top-3 text-gray-400">📧</span>
              </div>
            </div>

            <button
              onClick={handleSearch}
              className="w-full mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 transition-all"
            >
              {loading ? "Searching..." : "Search Orders"}
            </button>
          </div>
          <div className="bg-white p-4 rounded-lg border border-gray-200 sm:w-[80%]  w-[100%]">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Orders List
            </h2>

            {orders?.length > 0 ? (
              orders.map((order) => (
                <div
                  key={order._id}
                  className="p-4 border-b rounded-lg shadow-md flex flex-col sm:flex-row sm:items-start"
                >
                  <div className="w-full sm:w-2/3 lg:w-3/4 pr-0 sm:pr-4 flex-grow">
                    <div className="text-sm text-gray-800 mb-2">
                      <span className="font-semibold">Order ID:</span>{" "}
                      {order.orderId}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">
                        Order Date & Time:
                      </span>{" "}
                      {new Date(order?.orderDate).toLocaleString()}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Email:</span>{" "}
                      {order.billingAddress?.email}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Phone:</span>{" "}
                      {order.billingAddress?.phone}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Shipping Address:</span>{" "}
                      {order?.billingAddress?.streetAddress},{" "}
                      {order?.billingAddress?.city},{" "}
                      {order?.billingAddress?.state},{" "}
                      {order?.billingAddress?.pinCode}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Total Price:</span> ₹
                      {order?.totalPrice}
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Status:</span>{" "}
                      {order?.status}
                    </div>

                    {order?.trackingLink != null && (
                      <div className="text-sm text-gray-600 mb-2">
                        <span className="font-semibold">Tracking Link :</span>{" "}
                        <a
                          href={order?.trackingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 font-medium underline hover:text-blue-800"
                        >
                          {order?.trackingLink}
                        </a>
                      </div>
                    )}
                  </div>

                  <div className="w-full sm:w-full lg:w-full mt-4 sm:mt-0">
                    <div className="overflow-x-auto">
                      <table className="w-full table-auto border-collapse">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-2 py-2 text-left text-xs sm:text-sm font-semibold text-gray-700">
                              Product
                            </th>
                            <th className="px-2 py-2 text-left text-xs sm:text-sm font-semibold text-gray-700 ">
                              Qty
                            </th>
                            <th className="px-2 py-2 text-left text-xs sm:text-sm font-semibold text-gray-700">
                              Price
                            </th>
                            <th className="px-2 py-2 text-left text-xs sm:text-sm font-semibold text-gray-700 hidden sm:table-cell">
                              Image
                            </th>
                            {order?.status == "delivered" && (
                              <th className="px-2 py-2 text-left text-xs sm:text-sm font-semibold text-gray-700">
                                ADD Review
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {order.items?.map((item) => (
                            <tr key={item._id} className="border-b">

                              <td className="px-2 py-2">
                                <div className="w-10 sm:w-24  md:whitespace-normal line-clamp-2 text-xs sm:text-sm">
                                  {item?.title}
                                </div>
                              </td>
                              <td className="  px-1 py-1  text-xs sm:text-sm ">
                                {item.quantity}
                              </td>
                              <td className="px-2 py-2 text-xs sm:text-sm">
                                ₹{item.price}
                              </td>
                              <td className="px-2 py-2 hidden sm:table-cell">
                                {item?.productImage && (
                                  <img
                                    loading="lazy"
                                    className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded-md"
                                    src={item?.productImage}
                                    alt={item?.productId?.title}
                                  />
                                )}
                              </td>
                              <td>
                                {order?.status == "delivered" && (
                                  <button
                                    onClick={() => _handleReview(item)}
                                    className="mt-2 bg-orange-300 text-white font-bold px-2 py-1 rounded-md shadow-md hover:bg-blue-700 transition 
                                        text-xs sm:text-sm md:text-base 
                                        px-1 sm:px-3 md:px-2 
                                        py-1 sm:py-1 md:py-2"
                                  >
                                    Rate Product
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* ACTION BUTTONS */}

                      <div
                        className="flex flex-wrap gap-3 mt-4"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: "12px",
                          paddingTop: "15px",
                        }}
                      >
                        <button
                          onClick={() =>
                            handleActionClick(order, "cancelled")
                          }
                          className="hover:bg-orange-600 border hover:text-white border-black  text-black  px-5  py-2.5  rounded-xl    text-sm font-semibold  shadow-sm transition-all duration-200 "
                        >
                          {loading ? "Processing..." : "Cancel Order"}
                        </button>

                        {order?.status == "delivered" && (
                          <>
                            <button
                              onClick={() =>
                                handleActionClick(order, "return")
                              }
                              className="hover:bg-orange-600 border hover:text-white border-black  text-black  px-5  py-2.5  rounded-xl    text-sm font-semibold  shadow-sm transition-all duration-200 "
                            >
                              {loading ? "Processing..." : "Return Order"}
                            </button>

                            <button
                              onClick={() =>
                                handleActionClick(order, "replacement")
                              }
                              className="hover:bg-orange-600 border hover:text-white border-black  text-black  px-5  py-2.5  rounded-xl    text-sm font-semibold  shadow-sm transition-all duration-200 "
                            >
                              {loading ? "Processing..." : "Replacement"}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-gray-500">
                No orders found.
              </div>
            )}
          </div>
        </main>
      </div>
      {orders?.length > 0 &&
        orders?.map((order) => {
          return (
            <OrderTracking
              statusHistory={order?.statusHistory || []}
              estimatedDate={estimatedDate}
            />
          );
        })
      }
      {showOtpModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl animate-fadeIn">
            <div className="bg-orange-500 px-6 py-4">
              <h2 className="text-2xl font-bold text-white">
                Verify Request
              </h2>

              <p className="text-sm text-gray-300 mt-1 capitalize">
                {selectedAction} Request Verification
              </p>
            </div>

            {/* BODY */}

            <div className="p-6">

              {/* ORDER ID */}

              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Order ID
                </label>

                <input
                  type="text"
                  value={selectedOrder?.orderId || ""}
                  disabled
                  className="w-full border border-gray-300 bg-gray-100 rounded-xl px-4 py-3 outline-none"
                />
              </div>

              {/* REASON */}

              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Reason
                </label>

                <textarea
                  rows={4}
                  value={reason}
                  onChange={(e) =>
                    setReason(e.target.value)
                  }
                  placeholder="Write your reason..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-black resize-none"
                />
              </div>

              {/* OTP */}

              <div className="mb-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  OTP Verification
                </label>

                <input
                  type="text"
                  value={otp}
                  required
                  onChange={(e) =>
                    setOtp(e.target.value)
                  }
                  placeholder="Enter OTP"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-black tracking-[5px] text-lg font-semibold"
                />
              </div>

              <p className="text-xs text-gray-500 mt-2">
                OTP has been sent successfully to your registered mobile/email.
              </p>

              {/* BUTTONS */}

              <div className="flex justify-end gap-3 mt-8">

                <button
                  onClick={() => {
                    setShowOtpModal(false);
                    setOtp("");
                    setReason("");
                  }}
                  className="border border-gray-300 hover:bg-gray-100 px-6 py-3 rounded-xl font-medium transition-all"
                >
                  Cancel
                </button>

                <button
                  onClick={handleVerifyOtp}
                  className="bg-orange-500 hover:bg-gray-800 text-white px-6 py-3 rounded-xl font-semibold transition-all"
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default AllOrders;
